import Axios from "../utils/Axios";

export const getSentRecd = async () => {
  const response = await Axios.get("/incoming-items/");
  return response.data;
};

export const getSentStockCurrent = async () => {
  const response = await Axios.get("/incoming-items/sent/current-month");
  return response.data;
};

export const getRecdStockCurrent = async () => {
  const response = await Axios.get("/incoming-items/recd/current-month");
  return response.data;
};

export const getSentStockPast = async () => {
  const response = await Axios.get("/incoming-items/sent/previous-month");
  return response.data;
};

export const getRecdStockPast = async () => {
  const response = await Axios.get("/incoming-items/recd/previous-month");
  return response.data;
};

export const getSentStockCustom = async (month) => {
  const response = await Axios.get(
    `/incoming-items/sent/custom-month?month=${month}`
  );
  return response.data;
};

export const getRecdStockCustom = async (month) => {
  const response = await Axios.get(
    `/incoming-items/recd/custom-month?month=${month}`
  );
  return response.data;
};

export const getPendingSentRecd = async () => {
  const response = await Axios.get("/incoming-items/pending/all");
  return response.data;
};

export const getPendingSentRecdById = async (partyId, partId) => {
  const response = await Axios.get(
    `/incoming-items/pending/${partyId}/${partId}`
  );
  return response.data;
};

export const lockChallan = async (id) => {
  const response = await Axios.put(`/incoming-items/lock-challan/${id}/`);
  return response.data;
};

export const getSentRecdEntry = async (id) => {
  const response = await Axios.get(`/incoming-items/entry/${id}`);
  return response.data;
};

export const addSentRecd = async (formData) => {
  const response = await Axios.post("/incoming-items/add", formData);
  return response.data;
};

export const editSentRecd = async (id, formData) => {
  try {
    const response = await Axios.put(`/incoming-items/edit/${id}`, formData);
    return response.data;
  } catch (error: any) {
    // Capture Flask error message
    const errorMessage =
      error.response?.data?.error || "Failed to delete entry";
    throw new Error(errorMessage);
  }
};

export const deleteSentRecd = async (id) => {
  try {
    const response = await Axios.delete(`/incoming-items/delete/${id}/`);
    return response.data;
  } catch (error: any) {
    // Capture Flask error message
    const errorMessage =
      error.response?.data?.error || "Failed to delete entry";
    throw new Error(errorMessage);
  }
};
export const getChallanDetailsCurrent = async () => {
  const response = await Axios.get(`/incoming-items/challans/current-month`);
  return response.data;
};

export const getChallanDetailsPast = async () => {
  const response = await Axios.get(`/incoming-items/challans/previous-month`);
  return response.data;
};

export const getChallanDetailsCustom = async (month) => {
  const response = await Axios.get(
    `/incoming-items/challans/custom-month?month=${month}`
  );
  return response.data;
};

export const downloadChallanData = async (startDate, endDate) => {
  try {
    const response = await Axios.get("/incoming-items/challans/download", {
      params: { start_date: startDate, end_date: endDate },
      responseType: "blob",
    });

    const blob = new Blob([response.data], {
      type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
    });
    const url = window.URL.createObjectURL(blob);
    const link = document.createElement("a");
    link.href = url;
    link.download = `challan-data-${startDate}-to-${endDate}.xlsx`;
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
    window.URL.revokeObjectURL(url);
  } catch (error: any) {
    let responseData = error.response?.data;
    if (responseData instanceof Blob) {
      try {
        responseData = JSON.parse(await responseData.text());
      } catch {
        responseData = null;
      }
    }
    throw new Error(responseData?.error || "Failed to download challan data");
  }
};

export const getChallanItems = async (challanId) => {
  const response = await Axios.get(`/incoming-items/challan/${challanId}/`);
  return response.data;
};

export const deleteChallan = async (challanId) => {
  const response = await Axios.delete(
    `/incoming-items/challan/delete/${challanId}/`
  );
  return response.data;
};

export const createIncomingChallan = async (formData) => {
  try {
    const response = await Axios.post(
      "/incoming-items/challan/create",
      formData,
      {
        responseType: "blob", // for the excel  file
      }
    );
    // Create a blob URL for the file
    const blob = new Blob([response.data], {
      type: "application/pdf",
    });
    const url = window.URL.createObjectURL(blob);

    // Create a link element and simulate a click to trigger the download
    const a = document.createElement("a");
    a.href = url;
    a.download = "challan.pdf";
    document.body.appendChild(a);
    a.click();
    document.body.removeChild(a);

    // Optionally, revoke the blob URL after use
    window.URL.revokeObjectURL(url);
    return response.data;
  } catch (error) {
    console.error("Error downloading file:", error);
  }
};

export const createIncomingBulkChallan = async (formData) => {
  let response;
  const apiLink = "/incoming-items/bulk/create";
  try {
    if (formData?.status?.value === 0) {
      response = await Axios.post(apiLink, formData, {
        responseType: "blob", // for the excel  file
      });
      // Create a blob URL for the file
      const blob = new Blob([response.data], {
        type: "application/pdf",
      });
      const url = window.URL.createObjectURL(blob);

      // Create a link element and simulate a click to trigger the download
      const a = document.createElement("a");
      a.href = url;
      a.download = "challan.pdf";
      document.body.appendChild(a);
      a.click();
      document.body.removeChild(a);

      // Optionally, revoke the blob URL after use
      window.URL.revokeObjectURL(url);
    } else {
      response = await Axios.post(apiLink, formData);
    }

    return response.data;
  } catch (error: any) {
    let responseData = error.response?.data;

    // Axios returns error responses as Blob too when responseType is "blob".
    if (responseData instanceof Blob) {
      try {
        responseData = JSON.parse(await responseData.text());
      } catch {
        responseData = null;
      }
    }

    const apiError: any = new Error(
      responseData?.error || "Failed to create challan"
    );
    apiError.code = responseData?.code;
    apiError.status = error.response?.status;
    apiError.responseData = responseData;
    throw apiError;
  }
};

export const getIncomingChallanPDF = async (challanId) => {
  try {
    const response = await Axios.get(
      `/incoming-items/challan/${challanId}/pdf/`,
      {
        responseType: "blob", // for the excel  file
      }
    );
    // Create a blob URL for the file
    const blob = new Blob([response.data], {
      type: "application/pdf",
    });
    const url = window.URL.createObjectURL(blob);
    // Create a link element and simulate a click to trigger the download
    const a = document.createElement("a");
    a.href = url;
    a.download = "challan.pdf";
    document.body.appendChild(a);
    a.click();
    document.body.removeChild(a);
    // Optionally, revoke the blob URL after use
    window.URL.revokeObjectURL(url);
    return response.data;
  } catch (error) {
    console.error("Error downloading file:", error);
  }
};
